module.exports = __webpack_public_path__ + "static/media/3.89fd3718.JPG";